import { DISCOUNTS } from 'store/carInstance/constants';

import { FIELDS_NAME } from './BlockMain.constants';

export const getHiddenFields = ({
  carInstance,
  hiddenFields,
  isInCredit,
  onClickFullCalc,
  showRestrictions,
  version,
}) => {
  let fields = [];

  if (Array.isArray(hiddenFields)) {
    fields = hiddenFields;
  }

  const { discountType, isNew } = carInstance;
  const { discount, discountDirect } = version;

  const result = fields.reduce((acc, field) => {
    acc[field] = true;

    return acc;
  }, {});

  if (result[FIELDS_NAME.OFFER_PRICE] || !isNew) {
    result[FIELDS_NAME.IS_SET_DISCOUNT_MFR] = true;
    result[FIELDS_NAME.IS_SET_DISCOUNT_DIRECT] = true;
  } else {
    result[FIELDS_NAME.IS_SET_DISCOUNT_MFR] = discount <= 0;
    result[FIELDS_NAME.IS_SET_DISCOUNT_DIRECT] = discountDirect <= 0;
  }

  result[FIELDS_NAME.OFFER_PRICE] =
    (result[FIELDS_NAME.IS_SET_DISCOUNT_MFR] || discountType !== DISCOUNTS.mfr) &&
    (result[FIELDS_NAME.IS_SET_DISCOUNT_DIRECT] || discountType !== DISCOUNTS.direct);

  result[FIELDS_NAME.FULL_CALCULATION] = !onClickFullCalc;
  result[FIELDS_NAME.IS_IN_CREDIT] = !showRestrictions;
  result[FIELDS_NAME.BANK] = !showRestrictions || !isInCredit;

  return result;
};

export const shallowEqualObjects = (left, right) => {
  const leftKeys = Object.keys(left);
  const leftKeysSet = new Set(leftKeys);

  const rightKeys = Object.keys(right);
  const rightKeysSet = new Set(rightKeys);

  /**
   * Когда 'Set.prototype.intersection' станет стандартом или когда настроим babel можно будет упростить код
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set/intersection
   * */
  const keys = [...leftKeys, ...rightKeys].reduce((acc, key) => {
    if (leftKeysSet.has(key) && rightKeysSet.has(key)) {
      acc.push(key);
    }

    return acc;
  }, []);

  for (const key of keys) {
    if (left[key] !== right[key]) {
      return false;
    }
  }

  return true;
};

export const getYearList = (firstYear) => {
  const LAST_YEAR = new Date().getFullYear();

  const result = [];

  let id = 0;
  let currentYear = LAST_YEAR - id;

  while (currentYear >= firstYear) {
    result.push({ id: id + 1, value: currentYear });

    currentYear = LAST_YEAR - ++id;
  }

  return result;
};

export const findYearId = (yearList, year) => {
  const finded = yearList.find((option) => option.value === year);
  if (finded) {
    return finded;
  }

  return {};
};

export const getItemByValue = (list, value, returnFirst = false) => {
  const founded = list.find((item) => `${item.value}`.toUpperCase() === `${value}`.toUpperCase());

  if (returnFirst) {
    return founded || list[0];
  }

  return founded || {};
};

export const getListIdByValue = (list, value) => {
  const founded = list.find((item) => item.value === value);

  return founded ? founded.id : 0;
};

export const getListValueById = (list, id) => {
  const founded = list.find((item) => item.id === id);

  return founded ? founded.value : '';
};

export const getPriceString = (price) => {
  const isNegative = price < 0;
  const absPrice = Math.abs(price);
  const reversedPriceCharsArray = Array.from(absPrice.toString()).reverse();

  const reversedResult = reversedPriceCharsArray.reduce((acc, char, index, arr) => {
    acc.push(char);

    if (index === 0 || index === arr.length - 1) {
      return acc;
    }

    if ((index + 1) % 3 === 0) {
      acc.push(' ');
    }

    return acc;
  }, []);

  return `${isNegative ? '-' : ''}${reversedResult.reverse().join('')}`;
};

export const getOfferPrice = (price, discount, isSetDiscount) => {
  const offerPrice = Number(price) - (isSetDiscount ? Number(discount) : 0);
  return offerPrice < 0 ? 0 : offerPrice;
};

export const getDiscount = (discountType, version) => {
  switch (discountType) {
    case DISCOUNTS.mfr:
      return version.discount;
    case DISCOUNTS.direct:
      return version.discountDirect;
    default:
      return 0;
  }
};
